const hasAllCommiteeApproved = approvals => {
  return approvals?.every(el => el.status === 'accepted');
};

export default hasAllCommiteeApproved;
